import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

type TranslationToggleButtonProps = {
  showOriginal: boolean;
  onToggle: () => void;
  className?: string;
};

export const TranslationToggleButton = ({
  showOriginal,
  onToggle,
  className,
}: TranslationToggleButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      data-no-navigate
      className={cn(
        "w-fit text-xs font-medium text-rw-main hover:underline",
        className,
      )}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      {showOriginal
        ? t("common.showTranslation", {
            defaultValue: "Show translation",
          })
        : t("common.showOriginal", {
            defaultValue: "Show original",
          })}
    </button>
  );
};
